import React, { useEffect } from "react";
import { useApplicationContext } from "../../components/applicationComponents/context/applicationContext";
import ScreeningQuestionsComponent from "../../components/applicationComponents/screeningQuestions/ScreeningQuestionsComponent";

export default function ScreeningQuestionsPage() {
  const { setHeaderText } = useApplicationContext();
  useEffect(() => {
    setHeaderText({
      value: "Edit Screening Questions",
      icon: "view-app-icon icon-spec mr-3 mt-0",
    });
  }, []);

  return (
    <>
      <ScreeningQuestionsComponent disabled={false} />
    </>
  );
}
